export default "__VITE_ASSET__CNsGuXZp__"